"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelect = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var lodash_1 = require("lodash");
var react_1 = __importDefault(require("react"));
var Option = antd_1.Select.Option;
var MultiSelect = function (props) {
    var _a = props.cell, colSpan = _a.colSpan, options = _a.options, path = _a.path, rowSpan = _a.rowSpan;
    var styles = props.style;
    var onChangeV = props.onValueUpdate;
    return ((0, jsx_runtime_1.jsx)("td", __assign({ style: styles, colSpan: colSpan, rowSpan: rowSpan }, { children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ style: { marginBottom: 0 }, validateStatus: props.required && props.triedSubmitting ? 'error' : undefined }, { children: (0, jsx_runtime_1.jsx)(antd_1.Select, __assign({ mode: "multiple", style: styles, onChange: function (value) { return (onChangeV || lodash_1.noop)(path, value); } }, { children: (0, lodash_1.map)(options, function (option, key) { return ((0, jsx_runtime_1.jsx)(Option, __assign({ value: option.value }, { children: option.text }), key)); }) })) })) })));
};
exports.MultiSelect = MultiSelect;
